<template>
  <el-card
    class="background"
    v-loading="loading"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <div class="commission">
      <sirui-search
        ref="siruiSearch"
        :query="query"
        :columns="topColumn"
        @resetBtnClick="resetBtnClick"
        @searchBtnClick="search"
        @changeMethod="changeMethod"
      ></sirui-search>
      <div class="result-table">
        <sirui-table
          ref="siruiTable"
          :buttonList="menuButtonList"
          @chooseClick="chooseClick"
          :loading="loading"
          @handleSelectionChange="handleSelectionChange"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
          @dblclickEvent="dblclickEvent"
          :data="tableData"
          :paging="true"
          :setting="false"
          :customVisible="false"
          :columns="columnList"
          :cellClick="cellClick"
          :cellStyle="cellStyle"
        >
          <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
          <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
          <vxe-table-column
            v-for="(item, index) in columnList"
            :key="index"
            :fixed="item.fixed"
            :sortable="item.sortable"
            :field="item.field"
            :title="item.title ? $t(item.title) : null"
            :visible="item.visible"
            :type="item.type"
            :width="item.width"
          >
          </vxe-table-column>
        </sirui-table>
        <AddCommissionDialog
          v-if="dialogVisible"
          ref="AddCommissionDialogRefs"
          @close="closeDialog"
          :dialogVisible="dialogVisible"
          :dialogTitle="dialogTitle"
          :editId="editId"
        />
      </div>
    </div>
  </el-card>
</template>

<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import {
    searchColumns,
    defaultTableColumns,
    defaultMenuList,
    auditStatusList,
    effectiveStatusList,
  } from '../data';
  import { mapState } from 'vuex';
  import API from '@/api/intermodality/commission';
  // import DATA_BASE_API from '@/api/dataBase';
  import AddCommissionDialog from '../component/addCommissionDialog.vue';
  import XEUtils from 'xe-utils';
  import BASE_API from '@/api/dataBase.js';
  export default {
    name: 'CommissionOverview',
    mixins: [],
    components: { SiruiSearch, AddCommissionDialog },
    mounted() {
      this.$nextTick(() => {
        this.getData();
        this.getButtonList();
        this.getDepartmentList(this.userInfo.companyCode);
      });
    },
    data() {
      return {
        loading: false,
        query: {
          ruleCompanyNo: '',
          ruleDepartmentCode: '',
          ruleName: '',
          effectiveStatus: '',
          auditStatus: '',
          createPersonName: '',
          gmtCreateStart: '',
          gmtCreateEnd: '',
        },
        menuButtonList: [],
        defaultMenuList,
        defaultTableColumns,
        columnList: [],
        multipleSelection: [],
        tableData: [],
        dialogVisible: false,
        dialogTitle: '',
        editId: '',
        auditStatusList,
        effectiveStatusList,
        companyList: [],
        departList: [],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      topColumn() {
        return searchColumns(this);
      },
    },
    created() {
      this.query.ruleCompanyNo = this.userInfo.companyCode;
      // this.getPersonalCompanyList();
    },
    methods: {
      //获取当前列数据
      getColumnInfo() {
        this.getColumnList(this.defaultTableColumns).then((res) => {
          this.columnList = res;
        });
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e.length > 0 ? e : this.defaultMenuList;
          this.getColumnInfo();
        });
      },
      // 获取当前登录人所在的部门
      getDepartmentList(code) {
        const params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
          personCompanyCode: code,
        };
        this.$axios.post(BASE_API.GET_PERSON_API, params).then((res) => {
          if (res.data.code === 0) {
            this.departList = (res.data.data.personDepartmentInfo || []).map((v) => {
              return {
                label: v.personDepartmentName,
                value: v.personDepartmentCode,
              };
            });
          } else {
            this.departList = [];
          }
        });
      },
      changeMethod({ val, prop }) {
        if (prop == 'ruleCompanyNo') {
          this.query.ruleDepartmentCode = null;
          this.getDepartmentList(val);
        }
        console.log(val, prop, '触发');
        // const rowData = val[0];
      },
      resetBtnClick() {
        console.log('重置');
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getData();
      },
      search() {
        console.log(this.query, '搜索');
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getData();
      },
      dblclickEvent({ row }) {
        console.log('detail', row);
      },
      handleSizeChange() {
        this.getData();
      },
      handleCurrentChange() {
        this.getData();
      },
      handleSelectionChange(row) {
        this.multipleSelection = row;
      },
      getData() {
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const params = { ...this.query, pageNum, pageSize };
        if (params.ruleDepartmentCode) {
          params.scopeDepartmentNoList = [params.ruleDepartmentCode];
        }
        this.$axios.post(API.LIST_PAGE, params).then((res) => {
          if (res.data.code === 0) {
            this.tableData = res.data.data.records || [];
            this.tableData.forEach((item) => {
              item.auditStatusName = this.transferSelect(item.auditStatus, this.auditStatusList);
              if (item.effectiveStatus) {
                item.effectiveStatusName = this.transferSelect(
                  item.effectiveStatus,
                  this.effectiveStatusList
                );
              }
              item.validDate = `${item.validDateFrom.replaceAll(
                '-',
                '.'
              )}-${item.validDateUntil.replaceAll('-', '.')}`;
            });
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          }
        });
      },
      chooseClick(type) {
        console.log(type, 'type');
        if (type === 'create') {
          this.dialogVisible = true;
          this.dialogTitle = '新增佣金规则';
          this.editId = '';
        } else if (type === 'edit') {
          this.handleEdit();
        } else if (type === 'audit') {
          this.handleAudit();
        } else if (type === 'deactivate') {
          this.handleDeactivate();
        } else if (type === 'delete') {
          this.handleDelete();
        }
      },
      handleEdit() {
        if (this.resolveSelected()) {
          const selectedData = this.multipleSelection[0] || {};
          if (selectedData.auditStatus === '01' || selectedData.auditStatus === '04') {
            this.editId = selectedData.id;
            this.dialogVisible = true;
            this.dialogTitle = '编辑佣金规则';
          } else {
            return this.$message({
              showClose: true,
              message: '仅能选择审核状态为待提交，审核驳回的数据操作变价！',
              type: 'error',
            });
          }
        }
      },
      // 是否选择数据
      resolveSelected(type) {
        if (this.multipleSelection.length === 0) {
          this.$message({
            showClose: true,
            message: '请选择数据！',
            type: 'error',
          });
          return false;
        } else if (this.multipleSelection.length > 1) {
          if (type && type === 'more') return true;
          this.$message({
            showClose: true,
            message: '请选择一条数据！',
            type: 'error',
          });
          return false;
        }
        return true;
      },
      // 审核
      handleAudit() {
        if (this.resolveSelected()) {
          const selectedData = this.multipleSelection[0] || {};
          if (selectedData.auditStatus !== '02') {
            return this.$message({
              showClose: true,
              message: '仅能选择审核状态为“待审核”的数据操作审核！',
              type: 'error',
            });
          }
          const query = {
            id: selectedData.id,
            type: 'audit',
          };
          let path = {
            path: '/property/merchant/commission/detail',
            name: 'commissionAudit',
            meta: {
              keepAlive: true,
              title: '审核佣金规则',
            },
            query: query,
            // fromPath: {
            //   path: this.$route.path,
            //   name: this.$route.name,
            //   meta: { keepAlive: true },
            // },
            // toPath: {
            //   path: '/property/merchant/commission/detail',
            //   name: 'commissionAudit',
            //   meta: { keepAlive: false },
            //   query,
            // },
          };
          this.$router.push(path);
          // this.$store.dispatch('tagsView/backTabView', path).then(() => {
          //   this.$nextTick(() => {
          //     this.$router.push(path.toPath);
          //   });
          // });
        }
      },
      // 失效
      handleDeactivate() {
        if (this.resolveSelected()) {
          const selectedData = this.multipleSelection[0] || {};
          if (selectedData.effectiveStatus !== '02') {
            return this.$message({
              showClose: true,
              message: '该状态的数据不支持失效，请核实！',
              type: 'error',
            });
          }
          const ids = [selectedData.id];
          const params = ids;
          this.$axios.post(API.INVALID, params).then((res) => {
            console.log(res, 'INVALID');
            if (res.data.code === 0) {
              this.getData();
            }
          });
        }
      },
      // 删除
      handleDelete() {
        if (this.resolveSelected('more')) {
          let hasAuditStatusErrorStatus = false;
          let hasEffectiveStatusErrorStatus = false;
          this.multipleSelection.map((item) => {
            if (item.effectiveStatus === '02') {
              hasEffectiveStatusErrorStatus = true;
            }
            if (item.auditStatus === '02' || item.auditStatus === '03') {
              hasAuditStatusErrorStatus = true;
            }
          });
          console.log(hasAuditStatusErrorStatus, hasEffectiveStatusErrorStatus, 'hasErrorStatus');
          if (hasAuditStatusErrorStatus || hasEffectiveStatusErrorStatus) {
            return this.$message({
              showClose: true,
              message: '该状态的数据不支持删除，请核实！',
              type: 'error',
            });
          }
          const ids = [];
          this.multipleSelection.forEach((selected) => {
            ids.push(selected.id);
          });
          const params = ids;
          this.$axios.post(API.DELETE, params).then((res) => {
            console.log(res, 'DELETE');
            if (res.data.code === 0) {
              this.$message({
                showClose: true,
                message: '操作成功',
                type: 'success',
              });
              this.getData();
            }
          });
        }
      },
      closeDialog(val) {
        this.dialogVisible = false;
        if (val === 'refresh') {
          this.getData();
        }
      },
      transferSelect(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      cellStyle({ column }) {
        if (column.property == 'ruleNo') {
          // console.log('cellStyle', row, rowIndex, column, columnIndex);
          return {
            color: '#009fcc',
          };
        }
      },
      cellClick(val) {
        if (val.column?.property === 'ruleNo') {
          const query = {
            id: val.row.id,
            type: 'detail',
          };
          let path = {
            path: '/property/merchant/commission/detail',
            name: 'commissionDetail',
            meta: {
              keepAlive: true,
              title: '佣金规则详情',
            },
            query: query,
            // fromPath: {
            //   path: this.$route.path,
            //   name: this.$route.name,
            //   meta: { keepAlive: true },
            // },
            // toPath: {
            //   path: '/property/merchant/commission/detail',
            //   name: 'commissionAudit',
            //   meta: { keepAlive: false },
            //   query,
            // },
          };
          this.$router.push(path);
          // this.$store.dispatch('tagsView/backTabView', path).then(() => {
          //   this.$nextTick(() => {
          //     this.$router.push(path.toPath);
          //   });
          // });
        }
      },
    },
  };
</script>

<style lang="scss" scoped></style>
